module.exports = __webpack_public_path__ + "img/portfolio5.09db8359.jpg";